import { useTranslation } from 'react-i18next';
import { Text } from '@connect-x-app/hybrid-ui';
import {
  PUSH_NOTIFICATION_GROUPS_IN_ORDER,
  PushNotificationGroup,
  PushNotificationGroupState,
  PushNotificationSetting,
} from '@connect-x-app/shared-domain-models';
import { IconName } from '@connect-x-app/shared-types';
import { getPushNotificationGroupState } from '@connect-x-app/shared-utils';
import { APP_CONFIG_TEST_IDS } from '@connect-x-app/web-test-ids';
import { BlockRow } from '@connect-x-app/web-ui';

const ICON_BY_GROUP_STATE: Record<PushNotificationGroupState, IconName> = {
  CUSTOM: 'notificationBellCogOutline',
  OFF: 'notificationBellSlashOutline',
  ON: 'notificationBellOutline',
};

type Props = {
  onSelectGroup: (group: PushNotificationGroup) => void;
  pushNotifications: PushNotificationSetting[];
};

export const PushNotificationGroups = ({ onSelectGroup, pushNotifications }: Props) => {
  const { t } = useTranslation();

  const renderGroup = (group: PushNotificationGroup) => {
    const groupState = getPushNotificationGroupState(pushNotifications, group);

    return (
      <BlockRow
        icon={ICON_BY_GROUP_STATE[groupState]}
        key={group}
        label={t(`SETTINGS.PUSH_NOTIFICATION_GROUP.${group}`)}
        onClick={() => onSelectGroup(group)}
        testId={APP_CONFIG_TEST_IDS.settings.group(group)}
        trailing={
          <Text as="span" size="SM" uppercase weight="bold">
            {t(`SETTINGS.PUSH_NOTIFICATION_GROUP_STATE.${groupState}`)}
          </Text>
        }
      />
    );
  };

  return <div className="settings-group-list">{PUSH_NOTIFICATION_GROUPS_IN_ORDER.map(renderGroup)}</div>;
};
